/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusBenutzerDetailDto } from '../../models/lexplus-benutzer-detail-dto';

export interface AuthenticationControllerGetMyUserDetailsV1$Params {
}

export function authenticationControllerGetMyUserDetailsV1(http: HttpClient, rootUrl: string, params?: AuthenticationControllerGetMyUserDetailsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusBenutzerDetailDto>> {
  const rb = new RequestBuilder(rootUrl, authenticationControllerGetMyUserDetailsV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusBenutzerDetailDto>;
    })
  );
}

authenticationControllerGetMyUserDetailsV1.PATH = '/v1/authentication/my-user-details';
